// src/user/SecurityPanel.jsx
import React, { useState } from 'react';
import { auth } from '../firebase';
import { updatePassword } from 'firebase/auth';
import './SecurityPanel.css';

export default function SecurityPanel() {
  const [newPass, setNewPass] = useState('');
  const [message, setMessage] = useState('');

  const handleChangePassword = async () => {
    try {
      await updatePassword(auth.currentUser, newPass);
      setMessage('Password updated!');
    } catch (err) {
      setMessage(err.message);
    }
  };

  return (
    <div className="sp-container">
      <header className="sp-header"><h1>Security</h1></header>
      <div className="sp-content">
        <label>New Password:</label>
        <input
          type="password"
          value={newPass}
          onChange={e => setNewPass(e.target.value)}
        />
        <button onClick={handleChangePassword}>Change Password</button>
        {message && <p className={message.includes('updated') ? 'success' : 'error'}>{message}</p>}
      </div>
    </div>
  );
}
